import React, { useContext } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Badge, Button, Space, Tabs } from 'antd';

import EventCategoriesTable from '@totem/components/services/threats/configuration/EventCategoriesTable';
import EventCategoryEditModal from '@totem/components/services/threats/configuration/EventCategoryEditModal';
import EventConfigurationContext from '@totem/components/services/threats/configuration/EventConfigurationContext';
import EventConfigurationEditDrawer from '@totem/components/services/threats/configuration/EventConfigurationEditDrawer';
import EventConfigurationTable from '@totem/components/services/threats/configuration/EventConfigurationTable';
import DropDownFilters from '@totem/components/ui_components/reportSettings/dropDownFilters';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import { FilterField } from '@totem/components/ui_components/reportSettings/types';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

// Sort/filter/pagination state and persistence for the Configuration tab are handled by
// the shared InputContainer, applied to the already-fetched local `items` array in
// EventConfigurationTable rather than a server query -- see totem-web CLAUDE.md's
// "Reports" section. componentKey must stay unique across the app.
const CONFIGURATION_FILTER_KEYS = [
  'category',
  'status',
  'organization',
  'ticketCategory',
  'ticketSubCategory',
  'create',
];

const CONFIGURATION_FILTER_CONFIG: FilterField[] = [
  {
    key: 'category',
    label: 'Category',
    sortField: 'category',
    filterField: 'category',
    multiple: true,
    values: [],
    options: [],
  },
  {
    key: 'status',
    label: 'Status',
    sortField: 'status',
    filterField: 'status',
    multiple: true,
    values: [],
    options: [],
  },
  {
    key: 'organization',
    label: 'Organization',
    sortField: '',
    filterField: 'organization',
    multiple: true,
    values: [],
    options: [],
  },
  {
    key: 'ticketCategory',
    label: 'Ticket Category',
    sortField: '',
    filterField: 'ticketCategory',
    multiple: true,
    values: [],
    options: [],
  },
  {
    key: 'ticketSubCategory',
    label: 'Ticket Sub-Category',
    sortField: '',
    filterField: 'ticketSubCategory',
    multiple: true,
    values: [],
    options: [],
  },
  {
    key: 'create',
    label: 'Create Ticket',
    sortField: '',
    filterField: 'create',
    multiple: true,
    values: [],
    options: [],
  },
];

export const EventConfigurationExtra = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { categories, items, onAddCategory, onAddItem } = useContext(
    EventConfigurationContext,
  );
  const canEdit =
    permissions.internalSystemAdministrator.hasPermissions(userProfile);

  return (
    <Space>
      <Badge count={items.length} overflowCount={999} offset={[0, -7]}>
        Configuration&nbsp;&nbsp;
      </Badge>
      <Badge count={categories.length} overflowCount={999} offset={[0, -7]}>
        Categories&nbsp;&nbsp;
      </Badge>
      {canEdit && (
        <>
          <Button size="small" icon={<PlusOutlined />} onClick={onAddCategory}>
            Add Category
          </Button>
          <Button size="small" icon={<PlusOutlined />} onClick={onAddItem}>
            Add Configuration
          </Button>
        </>
      )}
    </Space>
  );
};

const EventConfigurationLayout = () => (
  <>
    <Tabs
      items={[
        {
          key: 'configuration',
          label: 'Configuration',
          children: (
            <InputContainer
              componentKey="admin.eventConfiguration"
              componentLabel="Event Configuration"
              filterConfig={CONFIGURATION_FILTER_CONFIG}
              defaultPageSize={10}
            >
              <DropDownFilters
                keys={CONFIGURATION_FILTER_KEYS}
                extra={null}
                showFilterChips
              />
              <EventConfigurationTable />
            </InputContainer>
          ),
        },
        {
          key: 'categories',
          label: 'Categories',
          children: <EventCategoriesTable />,
        },
      ]}
    />
    <EventCategoryEditModal />
    <EventConfigurationEditDrawer />
  </>
);

export default EventConfigurationLayout;
